import { render, staticRenderFns } from "./AllineaRose.vue?vue&type=template&id=4721f1ad&scoped=true&"
import script from "./AllineaRose.vue?vue&type=script&lang=js&"
export * from "./AllineaRose.vue?vue&type=script&lang=js&"
import style0 from "./AllineaRose.vue?vue&type=style&index=0&id=4721f1ad&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4721f1ad",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/diego/Desktop/code/asta-live/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4721f1ad')) {
      api.createRecord('4721f1ad', component.options)
    } else {
      api.reload('4721f1ad', component.options)
    }
    module.hot.accept("./AllineaRose.vue?vue&type=template&id=4721f1ad&scoped=true&", function () {
      api.rerender('4721f1ad', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/dialogs/AllineaRose.vue"
export default component.exports